import { atom } from 'recoil'

import { ConfirmModalProps } from './types'

const initConfirmModal = {
  isVisible: false,
  onOkFunction: Function,
  title: '',
  okText: 'ตกลง',
  bodyText: '',
  cancelText: 'ยกเลิก',
  okButtonProps: { type: 'primary', danger: false, loading: false },
  cancelButtonProps: undefined,
  dataTestId: undefined,
} as ConfirmModalProps

const confirmModalAtom = atom({
  key: 'confirmModalAtom',
  default: initConfirmModal,
})

export default confirmModalAtom
